import { useState, useEffect } from 'react'
import "../css/ComponentStyle.css";
import { useNavigate, useLocation } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouseChimney, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux';

const Sidebar = ({ isSidebarOpen, toggleSidebar, closeSidebar }) => {

  // Below 1024px the sidebar is an overlay, so picking an item must close it.
  // Above that it pushes the page and stays open, which is the point.
  const closeIfOverlay = () => {
    if (closeSidebar && window.matchMedia("(max-width: 1024px)").matches) {
      closeSidebar();
    }
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState("");
  const DemoGraphyData = useSelector((state) => state.user.demoDetails);


  useEffect(() => {
    if (DemoGraphyData) {
      setLoading(false);
    }
  }, [DemoGraphyData]);

  const PatientID = DemoGraphyData?.PatientId;

  // const userData = useSelector((state) => state.user.user);



  // var userPracticeID = userData ? userData.practiceID : null;

  // var userId = userData ? userData.userID : null;



  const updateActivePage = () => {
    const currentHash = window.location.hash.replace("/#/", "").replace("#/", "");
    setActivePage(currentHash || "BillingDashboard");
    localStorage.setItem("activePage", currentHash || "BillingDashboard");
  };

  useEffect(() => {

    updateActivePage();


    window.addEventListener("hashchange", updateActivePage);

    return () => {
      window.removeEventListener("hashchange", updateActivePage);
    };
  }, []);

  /**
   * Tells the sidebar how much header is sitting above it, as --hv-sidebar-top.
   *
   * The rail is pinned to the viewport and sized with calc(100vh - that value). Leave it
   * at zero and the rail runs exactly one header past the bottom of the screen, which put
   * Denial Management and Statement Workflow under the taskbar - unreachable no matter how
   * far you scrolled, because the overflow they needed was off-screen rather than inside
   * the rail.
   *
   * Measured, not assumed: .top-container is min-height with flex-wrap, so the header grows
   * a row taller as the window narrows. A hardcoded 60px would be wrong at most widths.
   *
   * It also tracks scroll. Once the header has scrolled away there is nothing above the rail
   * any more, so the offset falls to zero and the rail takes the full viewport instead of
   * leaving a dead gap at the bottom.
   */
  useEffect(() => {
    const shell = document.querySelector(".hv-shell");
    if (!shell || typeof window === "undefined") return undefined;

    let frame = 0;

    const measure = () => {
      frame = 0;
      // Distance from the top of the document to the shell === the header's full height.
      const headerHeight = shell.getBoundingClientRect().top + window.scrollY;
      // How much of that header is still on screen right now.
      const stillVisible = Math.max(0, Math.min(headerHeight, headerHeight - window.scrollY));
      document.documentElement.style.setProperty("--hv-sidebar-top", `${Math.round(stillVisible)}px`);
    };

    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(measure);
    };

    measure();

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);

    // The header re-wraps when the window narrows, which resize alone can miss.
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(schedule) : null;
    if (observer) observer.observe(document.body);

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (observer) observer.disconnect();
      document.documentElement.style.removeProperty("--hv-sidebar-top");
    };
  }, []);

  /**
   * In-app route change, not a new browser tab.
   *
   * This was `window.open('/#/' + pageName, '_blank')`, which made every click
   * on the menu boot the whole application again: the bundle is a single 4.5 MB
   * chunk with all 34 routes imported eagerly, so each tab re-downloaded it,
   * re-parsed it, re-mounted React and re-ran auth before it could draw
   * anything. Routing through the router reuses the app that is already
   * running, so the switch is immediate.
   */
  const handleMenuClick = (pageName) => {
    navigate(`/${pageName}`);
    closeIfOverlay();
  };



  const handleClick = (pageName) => {

    const newActivePage = `/${pageName}/${PatientID}`;

    localStorage.setItem("activePage", newActivePage);
    setActivePage(newActivePage);
    navigate(newActivePage);
  }




  const handleTabClick = (pageName) => {

    const newActivePage = `/${pageName}/${PatientID}/primary-insurance`;

    localStorage.setItem("activePage", newActivePage);
    setActivePage(newActivePage);
    navigate(newActivePage);
  }

  const handleDMClick = (pageName) => {

    const newActivePage = `/${pageName}/${PatientID}/Personal-info`;

    localStorage.setItem("activePage", newActivePage);
    setActivePage(newActivePage);
    navigate(newActivePage);
  }






  const location = useLocation();


  const isLoginPage = location.pathname === '/';

  if (isLoginPage) {
    return null;
  }



  const isLocPage = location.pathname === '/locations';

  if (isLocPage) {
    return null;
  }


  const isPatDashPage = location.pathname === '/patient-dashboard/biller-dashboard/:id';

  if (isPatDashPage) {
    return null;
  }



  return (
    <>
      {/* Open/closed is now the `is-open` class on .hv-shell in App; this
          element no longer positions itself. */}
      <aside className="hv-sidebar" aria-hidden={!isSidebarOpen}>
        <nav className="hv-sidebar__inner" aria-label="Main menu">
          {/* Was .close-btn: that rule is `color: white` + `float: right`,
              which on the now-white sidebar rendered an invisible X that still
              consumed a full flex row. .close-btn is shared with PatDashboard,
              so the class is swapped here rather than the rule changed.
              The empty <div className="logo" /> that followed is removed - it
              had no content but carried height: 30px. */}
          <button
            className="hv-sidebar__close"
            onClick={toggleSidebar}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>



          {loading && (
            <div className="overlay">
              <div className="spinner-container">
                <div className="spinner-grow text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-warning" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-info" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          )}

          {DemoGraphyData && DemoGraphyData.MRN ? (

            <ul className="nav-links">
              <div className="logo">
                <FontAwesomeIcon onClick={() => handleMenuClick('BillingdasboardV2')} icon={faHouseChimney} style={{ marginLeft: '10px' }} />
              </div>

              <li className={activePage.includes("PatientContacts") ? "active-record" : "menu"} onClick={() => handleDMClick('PatientContacts')}>DM</li>
              <li className={activePage.includes("GeneralDocuments") ? "active-record" : "menu"} onClick={() => handleClick('GeneralDocuments')}>GENERAL DOC</li>
              <li className={activePage.includes("patient-insurance") ? "active-record" : "menu"} onClick={() => handleTabClick('patient-insurance')}>Insurance</li>


            </ul>
          ) : (
            <>

              <ul className="nav-links">

                <li className={` ${activePage === 'Billingdasboard' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Billingdasboard')}>Home</li>

                <li className={` ${activePage === 'IntelliBill' ? 'active-record' : ''}`} onClick={() => handleMenuClick('IntelliBill')}>Intelli Bill </li>
               
                <li className={` ${activePage === 'Lab-Billing' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Lab-Billing')}>Lab Billing </li>
               
                <li className={` ${activePage === 'claim-approval' ? 'active-record' : ''}`} onClick={() => handleMenuClick('claim-approval')}>Approval </li>

                <li className={` ${activePage === 'ClaimStatus' ? 'active-record' : ''}`} onClick={() => handleMenuClick('ClaimStatus')}>Claim Status </li>
                <li className={` ${activePage === 'Fax' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Fax')}>Fax</li>

               
                <li className={` ${activePage === 'new-encounter' ? 'active-record' : ''}`} onClick={() => handleMenuClick('new-encounter')}>New Encounter </li>
                
                <li className={` ${activePage === 'posting-payments' ? 'active-record' : ''}`} onClick={() => handleMenuClick('posting-payments')}>Posting Payments </li>
                <li className={` ${activePage === 'UpdateCPT' ? 'active-record' : ''}`} onClick={() => handleMenuClick('UpdateCPT')}>Edit CPT</li>
                <li className={` ${activePage === 'InsurancePaymentReport' ? 'active-record' : ''}`} onClick={() => handleMenuClick('InsurancePaymentReport')}>Insurance Payment Report</li>
                <li className={` ${activePage === 'workableclaims' ? 'active-record' : ''}`} onClick={() => handleMenuClick('workableclaims')}>Workable Claims</li>
                <li className={` ${activePage === 'MedicalClaimMacro' ? 'active-record' : ''}`} onClick={() => handleMenuClick('MedicalClaimMacro')}>Macro</li>

                <li className={` ${activePage === 'Upload-RemittanceFiles' ? 'active-record' : ''}`} onClick={() => handleMenuClick('Upload-RemittanceFiles')}>Remittance Upload </li>

                <li className={` ${activePage === 'superbill' ? 'active-record' : ''}`} onClick={() => handleMenuClick('superbill')}>Superbill</li>

                <li className={` ${activePage === 'BillerPatientTracker' ? 'active-record' : ''}`} onClick={() => handleMenuClick('BillerPatientTracker')}>Patient Tracker</li>
                <li className={` ${activePage === 'DenialManagement' ? 'active-record' : ''}`} onClick={() => handleMenuClick('DenialManagement')}>Denial Management</li>                
                <li className={` ${activePage === 'PatientStatementsWorkflow' ? 'active-record' : ''}`} onClick={() => handleMenuClick('PatientStatementsWorkflow')}>Statement Workflow</li>                
               
              </ul>



            </>
          )}
        </nav>
      </aside>
    </>
  )
}

export default Sidebar